import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const ChargingHistoryFlashIcon = ({ primaryColor = '#414042', strokeColor = '#414042', size, style, secondaryColor, textColor, ...rest }) => (
    <SvgIcon viewBox='0 0 11.3 11.3' style={size ? { ...style, fontSize: size, width: size, height: size } : style} {...rest}>
        <path fill='none' stroke={strokeColor} strokeWidth='0.34' d='M5.65.17C2.62.17.17,2.62.17,5.65s2.45,5.48,5.48,5.48,5.48-2.45,5.48-5.48S8.67.17,5.65.17' />
        <polygon fill={primaryColor} points='7.88 2.67 6.33 4.86 8.15 4.86 4.11 9.59 5.32 6.05 4.28 6.05 5.37 2.7 7.88 2.67' />
    </SvgIcon>
);

export default ChargingHistoryFlashIcon;
